import { ICommonState, IReducerAction } from 'src/libraries/thunk.library';
import services from 'src/services/operator-pilot.service';
import { IOperatorPilot } from 'src/models/operator-pilot.model';

export const actionTypes = {
  OPERATOR_PILOT_FETCH: 'OPERATOR_PILOT_FETCH',
  OPERATOR_PILOT_ADD: 'OPERATOR_PILOT_ADD',
  OPERATOR_PILOT_UPDATE: 'OPERATOR_PILOT_UPDATE',
  OPERATOR_PILOT_DELETE: 'OPERATOR_PILOT_DELETE',
} as const;

// This is where we put the actions that have promise/async payload like HTTP request
export const asyncActions = {
  listGET: {
    type: actionTypes.OPERATOR_PILOT_FETCH,
    service: services.listGET,
  },
  addPOST: {
    type: actionTypes.OPERATOR_PILOT_ADD,
    service: services.addPOST,
    meta: { error: false },
  },
  updatePUT: {
    type: actionTypes.OPERATOR_PILOT_UPDATE,
    service: services.updatePUT,
    meta: { error: false },
  },
  itemDELETE: {
    type: actionTypes.OPERATOR_PILOT_DELETE,
    service: services.itemDELETE,
  },
};

export type IOperatorPilotAsync = typeof asyncActions;

export interface IOperatorPilotState extends ICommonState<IOperatorPilotAsync> {
  data?: IOperatorPilot;
  list: IOperatorPilot[];
  total: number;
}

export const defaultState: IOperatorPilotState = {
  status: {},
  list: [],
  total: 0,
};

const OperatorPilotReducer = (
  state: IOperatorPilotState = defaultState,
  action: IReducerAction<IOperatorPilotAsync>
): IOperatorPilotState => {
  switch (action.type) {
    case actionTypes.OPERATOR_PILOT_FETCH: {
      return {
        ...state,
        list: action.payload?.rows ?? [],
        total: action.payload?.count ?? 0,
      };
    }

    default: {
      return state;
    }
  }
};

export default OperatorPilotReducer;
